import { render, staticRenderFns } from "./PostDoc.vue?vue&type=template&id=32a74b91&"
import script from "./PostDoc.vue?vue&type=script&lang=js&"
export * from "./PostDoc.vue?vue&type=script&lang=js&"
import style0 from "./PostDoc.vue?vue&type=style&index=0&id=32a74b91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports